<template>
    <div class="element AutonumberField" :data-required="this.required" :class="error.error ? 'error' : ''">
        <labelElement v-bind="resolveProps('label', this)" :error="error" />
        <input
            class="input"
            type="text"
            :id="`field_${this.id}`"
            :name="this.name"
            :readonly="true"
            :placeholder="this.placeholder"
            :autocomplete="false"
            v-model="input"
        />
        <div v-if="error.error" class="error">{{ trans(error.message) }}</div>
    </div>
</template>

<script>
import {ref, watch} from "vue";

// Our form helpers
import useFormValidation from "./_validation";
import { propDefaults } from "./_props";

// Our helpers
import { mergeDeep } from "helpers/_objects";
import trans from "helpers/_translation";

import { resolveProps } from "formbuilder/fields/_props";
import labelElement from "formbuilder/elements/LabelElement.vue";

export default {
    props: mergeDeep(
        propDefaults,
        {

        }
    ),
    components: {
        labelElement
    },
    setup(props) {
        let input = ref("");
        const {validateTextField, error} = useFormValidation();
        const validateInput = () => {
            if (props.required) {
                validateTextField(props.label, input.value);
            }
        };

        watch(
            () => props.value,
            () => {
                input.value = props.value;
                if (!props.editing && !props.value) {
                    input.value = "-";
                }
            },
            {
                immediate: true
            }
        );

        return {
            resolveProps,

            input,
            error,
            validateInput,
            trans
        };
    },
}
</script>